"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _wrapRootElement = _interopRequireDefault(require("./wrapRootElement"));

exports.wrapRootElement = _wrapRootElement.default;